<template>
    <tr v-if="isEditing && tempAlert" class="border-t">
        <td class="py-0">
            <input
                v-model.number="tempAlert.Quantity"
                type="number"
                step="10"
                min="1"
                class="w-24 pr-0 text-sm py-1 rounded" />
        </td>
        <td>
            <NotificationModifier v-model="tempAlert.Modifier" />
        </td>
        <NotificationAlertActions editing @cancel="cancelEdit()" @save="saveAlert()" />
    </tr>
    <tr v-else class="border-t">
        <td>{{ quantityFormatted }}</td>
        <td>
            <ModifierBadge :modifier="props.alert.Modifier" />
        </td>
        <NotificationAlertActions :disabled="isDeleted" @delete="emits('delete', props.alert.Id)" @edit="editAlert()" />
    </tr>
    <tr v-if="errorQuantity">
        <td colspan="2" class="text-danger pt-0">
            {{ errorQuantity }}
        </td>
    </tr>
</template>
<script setup lang="ts">
const { t } = useI18n();
const props = defineProps<{ alert: StockAlert }>();
const emits = defineEmits<{ save: [value: StockAlert]; delete: [id: number]; cancel: [] }>();

const isEditing = ref(props.alert.Id < 1);
const tempAlert = ref<StockAlert>({ ...props.alert });
const errorQuantity = ref("");

const isDeleted = computed(() => props.alert.Status == AlertStatus.Deleted);
const quantityFormatted = computed(() => props.alert.Quantity.toLocaleString());

function validate(): boolean {
    errorQuantity.value = "";
    if (!tempAlert.value) return false;

    if (tempAlert.value.Quantity < 1) {
        errorQuantity.value = t("Notifications.AlertInvalidQuantity");
        return false;
    }

    if (tempAlert.value.Quantity % 1 !== 0) {
        errorQuantity.value = t("Notifications.AlertQuantityMustBeWholeNumber");
        return false;
    }

    return true;
}

function editAlert() {
    tempAlert.value = { ...props.alert };
    isEditing.value = true;
}

function saveAlert() {
    // final validate
    if (!validate()) return;

    emits("save", { ...tempAlert.value });
    isEditing.value = false;
}

function cancelEdit() {
    emits("cancel");
    isEditing.value = false;
}
</script>
